import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IDeleteStageRequest, IStage } from 'Data/interfaces/Obra/IObraStages';

export const useQueryDeleteStages = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IDeleteStageRequest) => {
      return ObrasApiV2.deleteStages(variables);
    },
    onMutate: async (variables) => {
      const previousStages = queryClient.getQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
      );

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        (oldData) => {
          return oldData?.filter((stage) => {
            return stage.TopicStageId !== variables.stageId;
          });
        },
      );

      return { previousStages };
    },
    onSuccess: async () => {
      toastHandler.showSuccess('Etapa excluída com sucesso!');
    },
    onError: async (error: any, variables, context) => {
      await queryClient.cancelQueries({
        queryKey: [STAGES_QUERY_KEY, variables.constructionStieId],
      });

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        context?.previousStages,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao excluir Etapa!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    deleteStage: mutate,
    isLoading: isPending,
  };
};
